import { Box } from '@material-ui/core';
import { formatPercent, Holder, HolderType } from '@nemuru-eng/js-api-client';

import { RelationOptions } from '@/components/modules/KYC/KYCLoan/shared/BorrowerInvitationSection/constants/RelationOptions';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteNationalityFormField } from '@/components/shared/components/NewContextForms/AutocompleteNationalityFormField/AutocompleteNationalityFormField';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { PhoneFormDoubleField } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/PhoneFormDoubleField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

interface HolderFormProps extends FormGridOptions {
  holder: Holder;
  type: HolderType;
}

export const HolderDetailsForm = ({ holder, type, fieldVariant, fullWidth }: HolderFormProps) => {
  const currentType = holder.types.find((holderType) => holderType === type);
  const isEditable = fieldVariant === FieldVariant.form;
  if (!currentType) return <></>;

  return (
    <Box pt={2}>
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        {isEditable ? (
          <>
            <TextFormField name={'firstName'} label={'FIRST_NAME'} value={holder.fullName.firstName} />
            <TextFormField name={'lastName'} label={'LAST_NAME'} value={holder.fullName.lastName} />
          </>
        ) : (
          <TextFormField
            name={'fullName'}
            label={'FULL_NAME'}
            value={`${holder.fullName.firstName} ${holder.fullName.lastName}`}
            dummyField
          />
        )}
        {currentType === HolderType.ATTORNEY && <TextFormField name={'email'} label={'EMAIL'} value={holder.email} />}
        {currentType === HolderType.ATTORNEY && (
          <PhoneFormDoubleField fieldVariant={fieldVariant} defaultValue={holder.phoneNumber} />
        )}
        {currentType === HolderType.ATTORNEY && (
          <DateFormField name={'grantingPowersDate'} label={'GRANTING_POWERS_DATE'} value={holder.grantingPowersDate} />
        )}
        {currentType === HolderType.SHAREHOLDER && (
          <NumberFormField
            name={'percentage'}
            label={'HOLDER_PERCENTAGE'}
            value={formatPercent(Number(holder.percentage))}
            valueUnit={isEditable ? '%' : ''}
            showIcon
          />
        )}
        {currentType === HolderType.ATTORNEY && (
          <SelectFormField
            name={'relationshipWithOwner'}
            label={'RELATIONSHIP_WITH_OWNER'}
            value={holder.relationshipWithOwner}
            selectOptions={RelationOptions}
          />
        )}
        <TextFormField name={'documentNumber'} label={'DOCUMENT_NUMBER'} value={holder.documentNumber} />
        {currentType === HolderType.ATTORNEY && (
          <DateFormField name={'expiration'} label={'EXPIRATION_DATE'} value={holder.expiration} />
        )}
        <DateFormField name={'birthDate'} label={'BIRTH_DATE'} value={holder.birthDate} />
        <AutocompleteNationalityFormField
          name={'birthCountry'}
          label={'BIRTH_COUNTRY'}
          value={holder.birthCountry}
          fieldVariant={fieldVariant}
        />
        <AutocompleteNationalityFormField
          name={'nationality'}
          label={'NATIONALITY'}
          value={holder.nationality}
          fieldVariant={fieldVariant}
        />
      </FormGridContainer>
    </Box>
  );
};
